import type { HistoryEntry } from '@shared/types/api';

interface Props {
  history: HistoryEntry[];
  onRollback(version: number): void;
}

export function AdminHistoryList({ history, onRollback }: Props) {
  if (!history || history.length === 0) return null;
  return (
    <div className="adm-history">
      <h3>Version history</h3>
      {history.map((h) => (
        <div key={h.version} className="adm-history__row">
          <div className="adm-history__meta">
            <strong>v{h.version}</strong> · {h.status}
            {h.published_at ? ` · ${new Date(h.published_at).toLocaleString()}` : ''}
            {h.publish_note ? ` · "${h.publish_note}"` : ''}
          </div>
          {h.status === 'published' && (
            <button
              className="adm-btn adm-btn--ghost"
              type="button"
              onClick={() => onRollback(h.version)}
            >
              Roll back to this
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
